import { render, staticRenderFns } from "./BlockCommercial.vue?vue&type=template&id=57250d7a&scoped=true&"
import script from "./BlockCommercial.vue?vue&type=script&lang=js&"
export * from "./BlockCommercial.vue?vue&type=script&lang=js&"
import style0 from "./BlockCommercial.vue?vue&type=style&index=0&id=57250d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57250d7a",
  null
  
)

export default component.exports